import { ADD_OPTIN, FAILURE_OPTIN, PARAMS_OPTIN, SUCCESS_OPTIN } from 'actions/optin';
import { combineReducers } from 'redux';

/**
 * @param {OptInUiState} [state]
 * @param {Action} [action]
 * @returns {OptInUiState}
 */
const uiReducer = (state = {}, action = { type: '', payload: null }) => {
  const { type } = action;

  switch (type) {
    case FAILURE_OPTIN:
      return { ...state, isLoading: false, hasError: true };
    case SUCCESS_OPTIN:
      return { ...state, isLoading: false, hasError: false };
    default:
      return state;
  }
};

/**
 * @param {OptInDomainState} [state]
 * @param {Action} [action]
 * @returns {OptInDomainState}
 */
const domainReducer = (state = {}, action = { type: '', payload: {} }) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_OPTIN:
      return {
        ...state,
        optins: payload,
        total: state.total + 1
      };
    case PARAMS_OPTIN:
      return { ...state, params: payload };
    case SUCCESS_OPTIN:
      return {
        ...state,
        optins: payload.data,
        total: Number(payload.total)
      };
    default:
      return state;
  }
};

const optInReducer = combineReducers({ domain: domainReducer, ui: uiReducer });

export default optInReducer;
